export interface LandingPageOutputApiModel {
    id: number;
    title: string;
    slug: string;
    author: string;
    draft: any;
    story_count: number;
    time_created: Date;
    public: boolean;
    active: boolean;
    creator_name?: string;
    board_visible?: boolean;
    show_submit_story_btn?: boolean;
}

export class LandingPageOutputApiModel {
    constructor(data?: Partial<LandingPageOutputApiModel>) {
        if (data)
            Object.assign(this, data);
    }
}


